import { Breadcrumb, Card, Col, EventHandler, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row, SwitchToggle } from "client/CommonComponents"
import './OutOfOffice.scss'
import { DatePicker } from "rsuite"
import permissions, { isAuthorized } from "client/utils/Permissions"
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup"
import moment from "moment"

const OutOfOffice = ({
    breadcrumlist,
    handleClickBack,
    values,
    handleChange,
    handleDateChange,
    handleSkipApproverToggleChange,
    handleCancelClick,
    handleSaveClick,
    errors,
    searchApprover,
    popupContent,
    primaryApproverList,
    secondaryApproverList,
    isCurrentSettingExist
    }:any) => {
    return (<>
            <div className='breadCrumbBlock'>
                <EventHandler onEvent={handleClickBack} data-attribute="OutOfOffice_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>             
                <div className='breadcrumbList'>
                    <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="OutOfOffice_Default_Breadcrumb" />
                </div>
            </div>
            {isAuthorized(permissions.ViewOOFSettings) ?
            <Card data-attribute="OutOfOffice_Default_Card">
            <div className='create-new-order-container oof-override'>
                <div className='grid-block pt-3 pb-0'>
                    <div className='mb-3 clearfix'>
                        <p className='pull-left blueLabel mt-2'>OUT OF OFFICE OVERRIDE</p>
                        <div className="oof-switchtoggle">
                            <SwitchToggle 
                                name="skipApprover"
                                checked={values.skipApprover} 
                                onChange={handleSkipApproverToggleChange}
                                disabled={values?.primaryApprover ? false : true}
                                 data-attribute="OutOfOffice_skipApprover_SwitchToggle" />
                            <span className="skip-approver">Skip Approver</span>
                        </div>
                    </div>
                    <div>
                        <Row>
                            <Col xs={12} sm={12} md={4} lg={3} className={'mb-3'}>
                                <Label required data-attribute="OutOfOffice_Default_Label">Primary Approver</Label>
                                <ReactSelectBox 
                                    name="primaryApprover"
                                    placeholder="Search Primary Approver"
                                    options={primaryApproverList}
                                    onChange={(value: any) => handleChange(value, "primaryApprover")}
                                    value={values?.primaryApprover}
                                    isSearchable={true}
                                    onInputChange={(value: any, action: any) => searchApprover(value, action, 'primaryApprover')}
                                    className={errors?.primaryApprover ? 'controlValidation' : ''}
                                 data-attribute="OutOfOffice_primaryApprover_SearchSelectBox" />  
                                {errors?.primaryApprover ? <p className='validMessage'>{errors?.primaryApprover}</p> : ""}                      
                            </Col>
                            <Col xs={12} sm={12} md={4} lg={3} className={'mb-3'}>
                                <Label required data-attribute="OutOfOffice_Default_Label_2">Backup Approver</Label>
                                <ReactSelectBox 
                                name="backupApprover"
                                placeholder="Search Backup Approver"
                                options={secondaryApproverList}
                                onChange={(value: any) => handleChange(value, "backupApprover")}
                                value={values?.backupApprover}
                                isSearchable={true}
                                onInputChange={(value: any, action: any) => searchApprover(value, action, 'backupApprover')}
                                className={errors?.backupApprover ? 'controlValidation' : ''}
                                isDisabled={values.skipApprover}
                                 data-attribute="OutOfOffice_backupApprover_SearchSelectBox" />
                                {errors?.backupApprover ? <p className='validMessage'>{errors?.backupApprover}</p> : ""}
                            </Col>
                            <Col xs={12} sm={12} md={4} lg={3} className={'mb-3'}>
                                <Label required data-attribute="OutOfOffice_Default_Label_3">Start Date</Label>
                                <DatePicker
                                    name="startDate" 
                                    placeholder="Select Date and Time"
                                    format="MM/dd/yyyy HH:mm" 
                                    value={values.startDate}
                                    onChange={(date: any) => handleDateChange(date, "startDate")}
                                    className={errors?.startDate ? 'controlValidation' : ''}
                                    shouldDisableDate={date => moment(date).isBefore(new Date(), 'day')}
                                />
                                {errors?.startDate ? <p className='validMessage'>{errors?.startDate}</p> : ""}
                            </Col>
                            <Col xs={12} sm={12} md={4} lg={3} className={'mb-3'}>
                                <Label required data-attribute="OutOfOffice_Default_Label_4">End Date</Label>
                                <DatePicker
                                    name="endDate" 
                                    placeholder="Select Date and Time"
                                    format="MM/dd/yyyy HH:mm" 
                                    value={values.endDate}
                                    onChange={(date: any) => handleDateChange(date, "endDate")}
                                    className={errors?.endDate ? 'controlValidation' : ''}
                                    shouldDisableDate={date => moment(date).isBefore(new Date(), 'day')}
                                />
                                {errors?.endDate ? <p className='validMessage'>{errors?.endDate}</p> : ""}
                            </Col>
                        </Row>
                        <div className="btn-block-oof">
                            <PrimaryButton 
                                text="Reset" 
                                className={'me-2'}
                                onClick={(e?: any) => handleSaveClick(e, 'clear')}
                                disabled={(values?.primaryApprover && (values?.backupApprover || values.skipApprover) && isCurrentSettingExist) ? false : true}
                             data-attribute="OutOfOffice_Default_Button" />
                            <OutlineButton 
                                text="Cancel" 
                                className={'me-2'}
                                onClick={handleCancelClick}
                             data-attribute="OutOfOffice_Default_Button_2" />
                            <PrimaryButton 
                                text="Save" 
                                className={'me-0'}
                                onClick={(e?: any) => handleSaveClick(e,'save')}
                                disabled={!isAuthorized(permissions.Create_Edit_Admin) }
                             data-attribute="OutOfOffice_Default_Button_3" />                   
                        </div>
                    </div>
                </div>
            </div>
            {popupContent.isDialogVisible ? <CancelConfirmationPopup
              hideDialog={!popupContent.isDialogVisible}
              onDismiss={popupContent.hideDialog}
              Popupcontent={popupContent}
              popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
              popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
            /> : ""}
            </Card>
            :
            <div className="access-denied"><h1>ACCESS DENIED</h1></div>
        }  
    </>)
}

export default OutOfOffice